import AdmsIdentifier from "./AdmsIdentifier";

export default class AdmsIdentifierList {
  constructor(name, initialValue, namespace, notationNameSpace, schemaAgencyNameSpace) {
    this.namespace = namespace;
    this.name = name;
    this.notationNameSpace = notationNameSpace;
    this.schemaAgencyNameSpace = schemaAgencyNameSpace;
    this.admsList = [];
    if (initialValue) {
      this.parseInputJSON(initialValue);
    } else {
      this.addValueObj();
    }
  }

  getNameSpace() {
    return this.namespace;
  }

  getAdmsIdentifiersList() {
    return this.admsList;
  }

  setAdmsIdentifiersList(fadmsList) {
    this.admsList = fadmsList;
  }

  removeValueObj(item, index) {
    if (index < 0 || index >= this.admsList.length) {
      return;
    }
    this.admsList.splice(index, 1);
  }

  addValueObj(obj) {
    const adms = new AdmsIdentifier(this.name, obj, this.namespace, this.notationNameSpace, this.schemaAgencyNameSpace);
    this.admsList.push(adms);
    // console.log("addValueObj", this.admsList);
  }

  parseInputJSON(inputJSON) {
    const obj = inputJSON[this.namespace];
    // const obj = inputJSON;
    // console.log(inputJSON);
    if (Array.isArray(obj)) {
      for (const entry of Object.entries(obj)) {
        const value = entry[1];
        // console.log(value);
        this.addValueObj(value);
      }
    } else {
      // console.log(obj);
      this.addValueObj(obj);
    }
  }

  getExpandedFormatValue() {
    const expandedList = [];
    for (let index = 0; index < this.admsList.length; index++) {
      const admsItem = this.admsList[index];
      expandedList.push(admsItem.getExpandedFormatValue());
    }
    return expandedList;
  }


  isEmpty() {
    let condition = true;
    for (let index = 0; index < this.admsList.length; index++) {
      const admsItem = this.admsList[index];
      condition = condition && admsItem.isEmpty();
    }
    return condition;
  }
}
